import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { EmployeeReadApiClient, People } from '~/services/Http';

export const GET_PUBLIC_PROFILE_SWR_KEY =
  'EmployeeReadApiClient.getPublicProfile';

export function useGetPublicProfile(args: {
  employeeId: string;
  lang?: string;
}): UseSWROutput<People.EmployeeProfileDto> {
  return useSWR(
    [GET_PUBLIC_PROFILE_SWR_KEY, args.employeeId, args?.lang ?? undefined],
    ([_, employeeId, lang]) =>
      EmployeeReadApiClient.getPublicProfile(employeeId, lang).then(
        (r) => r.data,
      ),
  );
}
